import _ from "lodash";
import { DataRow, Tab } from "../../../../../stores/TabsStore";
import { Change, Equipment, Event, Reason } from "../../../../../types/types";
import { DateTime, Duration } from "luxon";
import { t } from "i18next";
import { useEffect, useState } from "react";
import ReactEcharts from "echarts-for-react";
import { useAppStore } from "../../../../../stores/RootStore";
import { hexColor, rgbColor } from "../../../../../enums/colors";
import { TbCircleFilled } from "react-icons/tb";
import ReactDomServer from "react-dom/server";
import { useFetch } from "@/hooks/useFetch";

import { Button } from "@/ui/Button";
import EditLossesReasonsModal from "./Losses/EditLossesReasonsModal";


// 0: "equipment_item_id"
// 1: "event_date"
// 2: "shift_date"
// 3: "start"
// 4: "start_ts"
// 5: "finish"
// 6: "finish_ts"
// 7: "duration"
// 8: "state"
// 9: "equipment_item_status"
// 10: "personnel_id"
// 11: "access_token_id"
// 12: "equipment_item_division_id"
// 13: "personnel_division_id"
// 14: "state_changed"
// 15: "status_changed"
// 16: "person_changed"


export function Losses({ data, tab }: { data: DataRow[]; tab: Tab }) {
  let equipment = data[0].equipment
  let correctWithMaintenanceLoad = equipment.attributes.correct_maintenance_load

  let startIdles: any[] = []
  let endIdles: any[] = []

  const [loading, setLoading] = useState(true);

  const [changes, setChanges] = useState<Reason[]>([]);

  const [downtimes, setDowntimes] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);

  const from = tab.defaultValues?.dates?.from;
  const to = DateTime.fromJSDate(tab.defaultValues?.dates?.to!)
    .endOf("day")
    .toJSDate();

  const [{ response, isLoading, error }, doFetchChanges] = useFetch(
    `/directories/equipment_items/changes/filter?${equipment.id}&from=${from}&to=${to}`,
  );

  const [{ response: downtimesResponse }, doFetchDowntimes] = useFetch(
    `/directories/downtime_reasons`,
  );

  useEffect(() => {
    setLoading(true);
    doFetchChanges();
    doFetchDowntimes();
  }, []);

  useEffect(() => {
    if (!response?.data) return;
    let changes = response?.data as unknown as Change[];
    let nodes = changes
      ?.filter((change) => change.type == "equipment_item_downtime_changed")
      .map((change) => {
        return {
          id: change.id,
          date: DateTime.fromISO(change.attributes.at).toSeconds() - 8,
          // Для синхронизации времени начала смены и создания changes с меткой на начало смены -8 секунд
          downtime_reason: change.attributes.downtime_reason,
        };
      });
    setChanges(_.sortBy(nodes, []));
  }, [response]);

  useEffect(() => {
    if (!downtimesResponse) return;

    const downtimesData = downtimesResponse as unknown as {
      id: string;
      name: string;
    }[];

    const downtimesList = downtimesData.map((item) => {
      return { value: item.id, label: item.name };
    });

    setDowntimes(downtimesList);
  }, [downtimesResponse]);

  data.map(r => r.violations).map(e => {
    if(e.startWork.seconds > 0) (
      startIdles.push(e.start.eventTime)

      // diciplineIdles.push({type: "idle_in_start_of_shift", date: DateTime.fromSQL(e.start.eventTime!).toFormat("dd.MM.yyyy"), start: e.start.eventTime, end: e.startWork.eventTime, duration: e.startWork.seconds, interaction: e.startInteraction.time})
    )
    if(e.endWork.seconds > 0) (
      endIdles.push(e.end.eventTime)
      // diciplineIdles.push({type: "idle_in_end_of_shift", date: DateTime.fromSQL(e.start.eventTime!).toFormat("dd.MM.yyyy"), start: e.endWork.eventTime, end: e.end.eventTime, duration: e.endWork.seconds, interaction: e.endInteraction.time})
    )
  })

  let workedIdles = (equipment.attributes.is_main ? data.map(r => r.originalEvents.filter(e => Number(e[9]) === 0 && e[8] !== "worked").map(e => addShiftDurationToEvent(e, r.dateShift.duration))) : data.map(r => r.originalEvents.filter(e => Number(e[9]) === 0 && e[8] === "stopped").map(e => addShiftDurationToEvent(e, r.dateShift.duration)))).filter(e => Number(e[7]) !== 0)
  .flat()
  .map(e => {
    if(startIdles.includes(e[3]) && Number(e[7]) < 10800) {
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], "late_start", Number(e[7]) >= 600 ? 1 : 0, "no_reason", 1] as Event
    }
    else if(endIdles.includes(e[5]) && Number(e[7]) < 10800) {
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], "early_finish", Number(e[7]) >= 600 ? 1 : 0, "no_reason", 1] as Event
    } else {
      return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], "work_process", Number(e[7]) >= 600 ? 1 : 0, (Number(e[17]) - 1200) <= Number(e[7]) ? "empty_shifts" : "no_reason", (Number(e[17]) - 1200) <= Number(e[7]) ? 0 : 1] as Event
    }
  })

  

  if(correctWithMaintenanceLoad) {
    let maintenanceIdles = (equipment.attributes.is_main ? data.map(r => r.originalEvents.filter(e => Number(e[9]) === 5 && e[8] !== "worked").map(e => addShiftDurationToEvent(e, r.dateShift.duration))) : data.map(r => r.originalEvents.filter(e => Number(e[9]) === 5 && e[8] === "stopped").map(e => addShiftDurationToEvent(e, r.dateShift.duration))))
    .flat()
    .map(e => [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], "maintenance", Number(e[7]) >= 600 ? 1 : 0, "adjustment"] as Event)
    workedIdles = [...workedIdles, ...maintenanceIdles]
  } else {
    let maintenanceIdles: Event[] = []
    let eventsByStatus = data.map(r => r.originalEvents.filter(e => Number(e[15]) === 1).map(e => addShiftDurationToEvent(e, r.dateShift.duration))).flat()
    eventsByStatus.map((e, eind) => {
      if(Number(e[9]) === 5) {
        let afterEvent = eventsByStatus[eind + 1]
        return maintenanceIdles.push([e[0], e[1], e[2], e[3], e[4], afterEvent[3], afterEvent[4], Number(afterEvent[4]) - Number(e[4]), e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], e[17], "maintenance", Number(e[7]) >= 600, "adjustment", 1] as Event)
      } else {
        return maintenanceIdles
      }
    })
    workedIdles = [...workedIdles, ...maintenanceIdles]
  }

  

  let sumIdlesMoreThenTenMinutes = _.sum(workedIdles.filter(m => m[19] === 1 && m[21] === 1).map(m => m[7]))
  let sumIdlesAsShift = _.sum(workedIdles.filter(m => m[21] === 0).map(m => m[7]))
  let sumIdlesLessThenTenMinutes = _.sum(workedIdles.filter(m => m[19] === 0).map(m => m[7]))
  
  let totalIdles = equipment.attributes.is_main ? _.sumBy(data, 'availability.stopped.seconds') + _.sumBy(data, 'availability.off.seconds') : _.sumBy(data, 'availability.stopped.seconds')

  let [isEditOpen, setIsEditOpen] = useState(false);
    let [currentReason, setCurrentReason] = useState<{
      reason: Reason | undefined;
      idle: Event;
    }>();

    function openEditModal(reason: Reason | undefined, idle: Event) {
      setIsEditOpen(true);
      setCurrentReason({reason: reason, idle: idle});
    }

    function closeEditModal() {
      setIsEditOpen(false);
      setCurrentReason(undefined);
    }

  return (
    <div>
      <EquipmentIdles 
        data={workedIdles} 
        equipment={equipment}
        sumIdlesMoreThenTenMinutes={sumIdlesMoreThenTenMinutes}
        sumIdlesLessThenTenMinutes={sumIdlesLessThenTenMinutes}
        sumIdlesAsShift={sumIdlesAsShift}
        totalIdles={totalIdles}
      />
      <IdleBarChart data={workedIdles} />
      <div className="flex flex-col space-y-1 mt-10">
        <div className="h-6 w-full grid grid-cols-12 space-x-2 text-base font-medium px-2">
          <span className="col-span-2">{t('date')}</span>
          <span className="col-span-2">{t('start')}</span> 
          <span className="col-span-2">{t('finish')}</span>
          <span className="col-span-1">{t('duration')}</span>
          <span className="col-span-2">{t('category')}</span>
          <span className="col-span-3">{t(`reason`)}</span>
        </div>
        {_.orderBy(
          workedIdles.filter((i) => i[19] === 1),
          (el) => el[1],
          "asc",
        ).map((idle, idx) => {
          const reason = find_reason_change(Number(idle[4]), changes);
          return (
            <div
              key={idx}
              className="h-8 bg-muted rounded space-x-2 px-2 py-1 grid grid-cols-12 text-base"
            >
              <span className="col-span-2 uppercase">
                {DateTime.fromSQL(String(idle[1])).toFormat("dd.MM.yyyy")} (
                {DateTime.fromSQL(String(idle[1])).weekdayShort})
              </span>
              <span className="col-span-2">
                {DateTime.fromSQL(String(idle[3])).toFormat("HH:mm:ss")}
              </span>
              <span className="col-span-2">
                {DateTime.fromSQL(String(idle[5])).toFormat("HH:mm:ss")}
              </span>
              <span className="col-span-1">
                {Duration.fromObject({ seconds: Number(idle[7]) }).toFormat(
                  "hh:mm:ss",
                )}
              </span>
              <span className="col-span-2">{t(`${idle[18]}`)}</span>
              <span className="col-span-3">
                {idle[20] == "no_reason" ? (
                  <div>
                    {/* {reason ? reason.downtime_reason : t(`${idle[20]}`)} */}
                    <Button
                      size="xs"
                      variant="outline"
                      onClick={() => openEditModal(reason, idle)}
                    >
                      {reason
                        ? downtimes.find(
                            (s) => s.label == reason.downtime_reason,
                          )?.label
                        : t(`${idle[20]}`)}
                    </Button>
                  </div>
                ) : (
                  t(`${idle[20]}`)
                )}
              </span>
            </div>
          );
        })}
      </div>
      <EditLossesReasonsModal
        equipmentId={equipment.id}
        data={currentReason!}
        downtimes={downtimes}
        isEditOpen={isEditOpen}
        closeModal={closeEditModal}
        refreshChanges={doFetchChanges}
      />
    </div>
  )
}

const EquipmentIdles = ({
  data, 
  equipment,
  sumIdlesMoreThenTenMinutes,
  sumIdlesLessThenTenMinutes,
  sumIdlesAsShift,
  totalIdles
}
:
{
  data: Event[], 
  equipment: Equipment,
  sumIdlesMoreThenTenMinutes: number,
  sumIdlesLessThenTenMinutes: number,
  sumIdlesAsShift: number,
  totalIdles: number
}) => {
  const {theme} = useAppStore()
  let colorPalette = [hexColor.bigIdles, hexColor.smallIdles]

  const getOptions = () => ({
    series: [
      {
        name: `${equipment.attributes.name}`,
        type: "pie",
        radius: ['55%', '90%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: theme === 'light' ? hexColor.background : hexColor.foreground,
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        labelLine: {
          show: false
        },
        color: colorPalette,
        data: [
          { name: "big_idles", value: sumIdlesMoreThenTenMinutes, color: hexColor.bigIdles },
          { name: "small_idles", value: sumIdlesLessThenTenMinutes, color: hexColor.smallIdles},
        ],
      },
    ]
  });

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 my-4 gap-4 text-sm">
      <div className="flex w-full justify-center lg:px-6">
        <ReactEcharts option={getOptions()} style={{ height: 120, width: 120 }} opts={{renderer: 'svg'}} />
      </div>
      <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
          <div className="grid grid-cols-2">
            <div className="flex font-semibold">{t('total')}</div>
            <div className="flex font-semibold">{Duration.fromObject({seconds: totalIdles}).toFormat('hh:mm:ss')}</div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.bigIdles}}/>
                <span className="text-secondary-foreground">{t('big_idles')}:</span>
              </div>
              <span className="font-medium text-base">{Duration.fromObject({seconds: sumIdlesMoreThenTenMinutes}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[19] === 1).length})</span>
            </div>
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.smallIdles}}/>
                <span className="text-secondary-foreground">{t('small_idles')}:</span>
              </div>
              <span className="font-medium text-base">{Duration.fromObject({seconds: sumIdlesLessThenTenMinutes}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[19] === 0).length})</span>
            </div>
          </div>
          <div className="grid grid-cols-2">
            <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.emptyShiftsIdles}}/>
                <span className="text-secondary-foreground">{t('empty_shifts')}:</span>
              </div>
              <span className="font-medium text-base">{Duration.fromObject({seconds: sumIdlesAsShift}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[21] === 0).length})</span>
            </div>
            {/* <div className="flex flex-col">
              <div className="flex items-center space-x-2">
                <TbCircleFilled className="w-3 h-3" style={{color: hexColor.service}}/>
                <span className="text-secondary-foreground">{t('small_idles')}:</span>
              </div>
              <span className="font-medium text-base">{Duration.fromObject({seconds: sumIdlesLessThenTenMinutes}).toFormat('hh:mm:ss')}</span>
            </div> */}
          </div>
      </div>
      <div className="flex flex-col w-full gap-3 lg:border-l border-border lg:px-6">
        <div className="grid grid-cols-2">
          <div className="flex font-semibold">{t('idles_count')}</div>
          <div className="flex font-semibold">{data.filter(e => e[19] === 1).length} / {data.filter(e => e[19] === 0).length}</div>
        </div>
        <div className="grid grid-cols-2">
          <div className="flex flex-col">
            <div className="flex items-center space-x-2">
              <TbCircleFilled className="w-3 h-3" style={{color: hexColor.workProcessIdles}}/>
              <span className="text-secondary-foreground">{t('works_idles')}:</span>
            </div>
            <span className="font-medium text-base">{Duration.fromObject({seconds: _.sumBy(data.filter(wi => wi[18] === "work_process"), el => Number(el[7]))}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[18] === "work_process" && wi[19] === 1).length} / {data.filter(wi => wi[18] === "work_process" && wi[19] === 0).length})</span>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center space-x-2">
              <TbCircleFilled className="w-3 h-3" style={{color: hexColor.maintenanceIdles}}/>
              <span className="text-secondary-foreground">{t('maintenance_idles')}:</span>
            </div>
            <span className="font-medium text-base">{Duration.fromObject({seconds: _.sumBy(data.filter(wi => wi[18] === "maintenace"), el => Number(el[7]))}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[18] === "maintenace" && wi[19] === 1).length} / {data.filter(wi => wi[18] === "maintenace" && wi[19] === 0).length})</span>
          </div>
        </div>
        <div className="grid grid-cols-2">
          <div className="flex flex-col">
            <div className="flex items-center space-x-2">
              <TbCircleFilled className="w-3 h-3" style={{color: hexColor.lateStartIdles}}/>
              <span className="text-secondary-foreground">{t('late_start_idles')}:</span>
            </div>
            <span className="font-medium text-base">{Duration.fromObject({seconds: _.sumBy(data.filter(wi => wi[18] === "late_start"), el => Number(el[7]))}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[18] === "late_start" && wi[19] === 1).length} / {data.filter(wi => wi[18] === "late_start" && wi[19] === 0).length} )</span>
          </div>
          <div className="flex flex-col">
            <div className="flex items-center space-x-2">
              <TbCircleFilled className="w-3 h-3" style={{color: hexColor.earlyFinishIdles}}/>
              <span className="text-secondary-foreground">{t('early_finish_idles')}:</span>
            </div>
            <span className="font-medium text-base">{Duration.fromObject({seconds: _.sumBy(data.filter(wi => wi[18] === "early_finish"), el => Number(el[7]))}).toFormat('hh:mm:ss')} ({data.filter(wi => wi[18] === "early_finish" && wi[19] === 1).length} / {data.filter(wi => wi[18] === "early_finish" && wi[19] === 0).length})</span>
          </div>
        </div>
      </div>
    </div>
  )
}

interface GrpahData {
  name: string;
  type: string;
  data: number[];
  color: string;
  markLine?: any;
}

const IdleBarChart = ({data}:{data: Event[]}) => {
  let days = _.uniq(data.map(r => r[1]))
  let workProcess: number[] = []
  let maintenance: number[] = []
  let lateStart: number[] = []
  let earlyFinish: number[] = []
  let smallIdles: number[] = []
  let emptyShifts: number[] = []


  Object.entries(_.groupBy(data, el => el[1])).map(([day, dayData]) => {
    workProcess.push(_.sumBy(dayData.filter(e => e[18] === "work_process" && e[19] === 1 && e[21] === 1), e => Number(e[7])))
    maintenance.push(_.sumBy(dayData.filter(e => e[18] === "maintenance" && e[19] === 1 && e[21] === 1), e => Number(e[7])))
    lateStart.push(_.sumBy(dayData.filter(e => e[18] === "late_start" && e[19] === 1 && e[21] === 1), e => Number(e[7])))
    earlyFinish.push(_.sumBy(dayData.filter(e => e[18] === "early_finish" && e[19] === 1 && e[21] === 1), e => Number(e[7])))
    smallIdles.push(_.sumBy(dayData.filter(e => e[19] === 0 && e[21] === 1), e => Number(e[7])))
    emptyShifts.push(_.sumBy(dayData.filter(e => e[21] === 0), e => Number(e[7])))
  })

  const graphData: GrpahData[] = [
    {
      name: "work_process",
      type: "bar",
      data: workProcess!,
      color: rgbColor.workProcessIdles,
    },
    { name: "maintenance", type: "bar", data: maintenance!, color: rgbColor.maintenanceIdles },
    { name: "late_start", type: "bar", data: lateStart!, color: rgbColor.lateStartIdles },
    { name: "early_finish", type: "bar", data: earlyFinish!, color: rgbColor.earlyFinishIdles },
    { name: "small_idles", type: "bar", data: smallIdles!, color: rgbColor.smallIdles },
    { name: "empty_shifts", type: "bar", data: emptyShifts!, color: rgbColor.emptyShiftsIdles },
  ];

  const getOptions = () => ({
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
      formatter: function (params: {name: any; seriesName: string; value: (number | string | undefined)[] }[]) {
        return ReactDomServer.renderToStaticMarkup(<Tooltip params={params} />);
      }
    },
    legend: {
      icon: "circle",
      bottom: 0,
      formatter: function (name: string) {
        return t(name);
      }
    },
    grid: {
      left: "0",
      right: "0%",
      bottom: "30px",
      top: "10px",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: days,
        axisLabel: {
          formatter: function (value: string) {
            return DateTime.fromSQL(value).toFormat("dd");
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        splitLine: {
          lineStyle: {
            color: "rgba(128,128,128,0.1)",
          },
        },
        position: "left",
        axisLabel: {
          max: 86400,
          formatter: function (value: string) {
            return `${Duration.fromObject({seconds: Number(value)}).toFormat("hh:mm:ss")}`;
          },
        },
      },
    ],
    series: graphData,
  });

  return (
    <ReactEcharts option={getOptions()} style={{ height: 200, width: "100%" }} opts={{ renderer: "canvas" }} />
  )
}

const Tooltip = ({ params }: { params: { name: any; seriesName: string; value: (number | string | undefined)[] }[] }) => {
  let date = DateTime.fromSQL(params[0].name!)
  return (
    <div className="relative bg-background">
      <div className="font-bold uppercase pb-3 flex w-full justify-between">
        <span>{date.toFormat("dd.MM.yyyy")} ({date.weekdayShort})</span>
        <span>{Duration.fromObject({seconds: _.sumBy(params, el => Number(el.value))}).toFormat("hh:mm:ss")}</span>
      </div>
      <div className="flex flex-col gap-1 w-48 ">
        {params.map(item => (
          <div key={item.name} className="flex w-full justify-between ">
            <div>{t(`${item.seriesName}`)}</div>
            <div className="font-bold">{Duration.fromObject({seconds: Number(item.value)}).toFormat("hh:mm:ss")}</div>
          </div>
        ))}
        
      </div>

    </div>
  );
};

function addShiftDurationToEvent(e: Event, duration: number) {
  return [e[0], e[1], e[2], e[3], e[4], e[5], e[6], e[7], e[8], e[9], e[10], e[11], e[12], e[13], e[14], e[15], e[16], duration]
}

function find_reason_change(
  at: number,
  changes: { id: string; downtime_reason: string; date: number }[],
) {
  return changes.find((change) => change.date == at);
}